// react
import { useState } from 'react';

// mui
import { Button, Stack, TextField } from '@mui/material';

// components
import { ModalPageTemplate } from '@/pwa/templates/ModalPageTemplate/ModalPageTemplate';
import { PageTemplate } from '@/pwa/templates/PageTemplate/PageTemplate';
import { PageHeader } from '@/pwa/atoms/PageHeader/PageHeader';

export interface InviteCodeV2Props {
  email?: string;
  onSubmit: (code: string) => void;
  onResend: () => void;
  onBack?: () => void;
  helperText?: string;
}

export const InviteCodeV2 = ({
  email,
  onSubmit,
  onResend,
  onBack,
}: InviteCodeV2Props) => {
  const [code, setCode] = useState('');

  const description = email
    ? `Enter the 6-digit invite code we just sent to ${email}.`
    : 'Enter the 6-digit invite code we just sent to your email.';

  return (
    <ModalPageTemplate onBack={onBack}>
      <PageTemplate
        maxWidth='xs'
        headerSlot={
          <PageHeader title='Enter Invite Code' description={description} />
        }
        contentSlot={
          <form
            onSubmit={(e) => {
              e.preventDefault();
              onSubmit(code);
            }}
          >
            <Stack
              sx={{
                gap: 2,
              }}
            >
              <TextField
                label='KareHero Invite Code'
                variant='standard'
                placeholder='••••••'
                size='medium'
                value={code}
                onChange={(e) => setCode(e.target.value)}
                helperText='Enter the 6-digit code.'
                fullWidth
              />
              <Button
                aria-label='Verify Access'
                variant='contained'
                type='submit'
              >
                Verify Code
              </Button>
              <Button
                aria-label='Resend Code'
                variant='text'
                onClick={onResend}
              >
                Resend Code
              </Button>
            </Stack>
          </form>
        }
      />
    </ModalPageTemplate>
  );
};

InviteCodeV2.displayName = 'InviteCodeV2';
export default InviteCodeV2;
